import React, { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import HRDashboard from "./HRDashboard";
import Dashboard from "./Dashboard";
import { DashboardPage } from "../DashboardPage";

const DashboardSwitcher = () => {
  const { auth } = useSelector(
    ({ auth }) => ({
      auth: auth.coreModuleInfo,
    }),
    shallowEqual
  );

  // State to track which dashboard to show
  const [showHRDashboard, setShowHRDashboard] = useState(true);

  const toggleDashboard = () => {
    setShowHRDashboard((prev) => !prev);
  };

  // Only show the toggle button if user is hr_admin
  const isHRAdmin = auth?.role_slugs?.includes("hr_admin");

  return (
    <div>
      {isHRAdmin && showHRDashboard ? (
        <HRDashboard toggleDashboard={toggleDashboard} />
      ) : (
        // <Dashboard
        //   toggleDashboard={toggleDashboard}
        //   showHRDashboard={showHRDashboard}
        //   isHRAdmin={isHRAdmin}
        // />
        <DashboardPage
          toggleDashboard={toggleDashboard}
          showHRDashboard={showHRDashboard}
          isHRAdmin={isHRAdmin}
        />
      )}
    </div>
  );
};

export default DashboardSwitcher;
